import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-03482a6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white edit-emploi-du-temps-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Type d'emploi du temps "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date début "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Date fin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "border border-primary mb-10" }
const _hoisted_23 = { class: "row d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white" }, "Modifier les cours")
], -1))
const _hoisted_25 = { class: "col-md-5" }
const _hoisted_26 = { class: "d-flex float-end" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1))
const _hoisted_28 = { class: "marge-droite" }
const _hoisted_29 = { class: "row mt-10" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "badge bg-primary text-white fs-6 mb-10" }
const _hoisted_32 = { class: "row mt-10" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Jour "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Heure de début "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_37 = ["onChange"]
const _hoisted_38 = { class: "col-md-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Heure de fin "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_40 = ["onChange"]
const _hoisted_41 = { class: "col-md-5" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_43 = { class: "row mt-10" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Professeur "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Classe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_48 = { class: "col-md-2 d-flex align-items-center mt-30" }
const _hoisted_49 = { class: "form-check" }
const _hoisted_50 = ["id", "checked", "onChange"]
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "col-md-2 d-flex align-items-start" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_55 = { class: "col-md-12" }
const _hoisted_56 = {
  class: "alert alert-danger d-flex align-items-center",
  role: "alert"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-0" }, null, -1))
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "col-md-12" }
const _hoisted_61 = { class: "d-flex align-items-center" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "emploiDuTempsForm",
        onSubmit: _ctx.editEmploiDuTemps,
        onInvalidSubmit: _ctx.handleInvalidSubmit,
        "validation-schema": _ctx.emploiDuTempsSchema,
        validateOnInput: false,
        validateOnMount: false,
        initialValues: {
          typeEmploi: _ctx.selectedTypeEmploi,
          dateDebut: _ctx.dateDebut,
          dateFin: _ctx.dateFin,
          niveau: _ctx.selectedNiveau,
          filiere: _ctx.selectedFiliere,
          coursAdded: _ctx.addedCours
        }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, { name: "typeEmploi" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps(field, {
                      options: _ctx.typeEmploiOptions,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner le type"
                    }), null, 16, ["options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "typeEmploi",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, {
                  name: "dateDebut",
                  type: "date",
                  min: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["min"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDebut",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, {
                  name: "dateFin",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateFin",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_Field, { name: "niveau" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.globalNiveauxOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onGlobalNiveauChange,
                      placeholder: "Sélectionner le niveau"
                    }), null, 16, ["options", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "niveau",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, { name: "filiere" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.globalFilieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label"
                    }, field, {
                      onChange: _ctx.onGlobalFiliereChange,
                      placeholder: "Sélectionner la filière",
                      disabled: !_ctx.globalSelectedNiveau || _ctx.isLoadingFilieres
                    }), null, 16, ["options", "onChange", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "filiere",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("button", {
                        class: "btn btn-success",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewCours && _ctx.addNewCours(...args)))
                      }, [
                        _hoisted_27,
                        _createTextVNode(" Ajouter un cours ")
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addedCours.filter(c => !c.toDelete), (cours, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: cours.tempId || cours.id
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("h5", _hoisted_31, " Cours " + _toDisplayString(index + 1), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].jour`
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({ ref_for: true }, field, {
                                options: _ctx.joursOptions,
                                searchable: true,
                                multiple: true,
                                mode: "tags",
                                "track-by": "value",
                                label: "label",
                                placeholder: "Sélectionner jours",
                                onChange: (value) => _ctx.onJourChange(index, value),
                                value: field.value
                              }), null, 16, ["options", "onChange", "value"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].jour`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].heureDebut`,
                            type: "time",
                            class: "form-control shadow-none text-black"
                          }, {
                            default: _withCtx(({ field }) => [
                              _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                type: "time",
                                class: "form-control shadow-none text-black",
                                onChange: (event) => _ctx.onHeureChange(index, 'debut', event)
                              }), null, 16, _hoisted_37)
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].heureDebut`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].heureFin`,
                            type: "time",
                            class: "form-control shadow-none text-black"
                          }, {
                            default: _withCtx(({ field }) => [
                              _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                type: "time",
                                class: "form-control shadow-none text-black",
                                onChange: (event) => _ctx.onHeureChange(index, 'fin', event)
                              }), null, 16, _hoisted_40)
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].heureFin`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].filiereNiveauMatiere`
                          }, {
                            default: _withCtx(({ field, value }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.globalMatieresOptions,
                                searchable: true,
                                "track-by": "value",
                                label: "label",
                                ref_for: true
                              }, field, {
                                value: value,
                                onChange: (matiereValue) => _ctx.onMatiereChange(index, matiereValue),
                                placeholder: "Sélectionner la matière",
                                disabled: !_ctx.globalSelectedNiveau || !_ctx.globalSelectedFiliere || _ctx.isLoadingMatieres
                              }), null, 16, ["options", "value", "onChange", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].filiereNiveauMatiere`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].professeur`
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.getProfesseursByMatiere(cours.matiereId),
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                ref_for: true
                              }, field, {
                                placeholder: "Sélectionner le professeur",
                                disabled: !cours.matiereId || !_ctx.getProfesseursByMatiere(cours.matiereId).length
                              }), null, 16, ["options", "disabled"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].professeur`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].classe`
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.classesOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                ref_for: true
                              }, field, {
                                placeholder: "Sélectionner la classe",
                                onChange: (classeValue) => _ctx.onClasseChange(index, classeValue)
                              }), null, 16, ["options", "onChange"])
                            ]),
                            _: 2
                          }, 1032, ["name"]),
                          _createVNode(_component_ErrorMessage, {
                            name: `coursAdded[${index}].classe`,
                            class: "text-danger"
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_Field, {
                            name: `coursAdded[${index}].estEnLigne`
                          }, {
                            default: _withCtx(({ field, handleChange }) => [
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  class: "form-check-input",
                                  id: `enligne-${index}`,
                                  checked: field.value === true,
                                  onChange: handleChange
                                }, null, 40, _hoisted_50),
                                _createElementVNode("label", {
                                  class: "form-check-label fw-semibold",
                                  for: `enligne-${index}`
                                }, " En ligne ", 8, _hoisted_51)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["name"])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          (_ctx.addedCours.length > 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-danger transition border-0 ps-8 pe-8 mt-30",
                                type: "button",
                                onClick: ($event: any) => (_ctx.removeCours(index))
                              }, " Supprimer ", 8, _hoisted_53))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.getCoursDisponibilite(cours.tempId, cours.id) && !_ctx.getCoursDisponibilite(cours.tempId, cours.id)?.available)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createElementVNode("div", _hoisted_56, [
                                _hoisted_57,
                                _createTextVNode(" Classe " + _toDisplayString(_ctx.getClasseLabel(cours.classe || null)) + " occupée sur au moins un jour ", 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _hoisted_58
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting 
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_63))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Modification en cours' : 'Modifier l\'emploi du temps'), 1)
                ], 8, _hoisted_62),
                _createVNode(_component_router_link, {
                  to: "/liste-emplois",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_64,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema", "initialValues"])
    ])
  ]))
}